export enum EntryFilterEnum {
	all = 'All',
	corrupted = 'Corrupted',
	pending = 'Pending',
	activated = 'Activated',
}
